import { CheckCircle, ClipboardText, XCircle } from 'phosphor-react';
import type { ComponentProps } from 'react';
import { ButtonCtaDanger, ButtonCtaGhost, ButtonCtaPrimary } from '../../lib/ds/button/button';
import { ergebnisLabelMapping, ErgebnisOptionenModal, useErgebnisOptionenModal } from './ergebnis-optionen-modal';
import type { AufgabeAbschliessenModel } from './model';
import type { AufgabeErgebnis } from './utils/constants';

type AufgabeAktionenProps = {
  aufgabe: AufgabeAbschliessenModel;
  onAfterAction?: () => void;
  onAufgabeAbschliessen: (id: string, ergebnis: string, ergebnisOption?: string, kommentar?: string) => Promise<unknown>;
  onAufgabeZwischenergebnisErfassen?: (id: string, zwischenErgebnisOption: string, kommentar: string) => Promise<unknown>;
  canAufgabeAbschliessen: ((aufgabe: { status: string | null; ergebnis: string | null }) => boolean);
};

export const AufgabeAktionen = ({ aufgabe, onAfterAction, onAufgabeAbschliessen, onAufgabeZwischenergebnisErfassen, canAufgabeAbschliessen }: AufgabeAktionenProps) => {
  const { ergebnis, openModal, closeModal } = useErgebnisOptionenModal();

  const handleErgebnisErfasst = async (ergebnis: AufgabeErgebnis | null, ...[ergebnisOption, kommentar]: Parameters<ComponentProps<typeof ErgebnisOptionenModal>['onErgebnisErfasst']>) => {
    if (ergebnis === 'Zwischenergebnis' && onAufgabeZwischenergebnisErfassen !== undefined) {
      await onAufgabeZwischenergebnisErfassen(aufgabe.id, ergebnisOption, kommentar);
    }

    if (ergebnis === 'Erfolgreich' || ergebnis === 'Erfolglos') {
      await onAufgabeAbschliessen(aufgabe.id, ergebnis, ergebnisOption, kommentar);
    }

    if (onAfterAction) {
      onAfterAction();
    }

    closeModal();
  };

  return (
    <>
      {(canAufgabeAbschliessen(aufgabe)) ? (
        <>
          <ButtonCtaPrimary icon={CheckCircle} onClick={() => openModal('Erfolgreich')}>{ergebnisLabelMapping.Erfolgreich}</ButtonCtaPrimary>
          {
            onAufgabeZwischenergebnisErfassen !== undefined ?
              <ButtonCtaGhost icon={ClipboardText} onClick={() => openModal('Zwischenergebnis')}>{ergebnisLabelMapping.Zwischenergebnis}</ButtonCtaGhost> :
              null
          }
          <ButtonCtaDanger icon={XCircle} onClick={() => openModal('Erfolglos')}>{ergebnisLabelMapping.Erfolglos}</ButtonCtaDanger>
        </>
      ) : null}
      <ErgebnisOptionenModal
        aufgabe={aufgabe}
        ergebnis={ergebnis}
        onClose={closeModal}
        onErgebnisErfasst={(ergebnisOption, kommentar) => handleErgebnisErfasst(ergebnis, ergebnisOption, kommentar)} />
    </>
  );
};
